import $ from 'jquery';
import noop from 'cmnjs/function/noop';
import config from './config';

let $title;
let $restOfContent;
let $navigationHeight;
let $floatingPoint;

let calculate = function () {
  $floatingPoint = $restOfContent.offset().top;
  $navigationHeight = $('.menu').height();
};

function needsFloating() {
  return config.$el.window.scrollTop() + $title.height() + $navigationHeight + 100 > $floatingPoint;
}

let floatTitle = function (weShallFloat) {
  $title[`${weShallFloat ? 'add' : 'remove'}Class`]('is-floating');
};

export default {
  init() {
    $title = $('.js-floating-title');
    $restOfContent = $('.standard-wrap__bottom');

    if (!$title.length && !$restOfContent.length) {
      calculate = noop;
      floatTitle = noop;
    } else {
      calculate();
      floatTitle(needsFloating());
    }
  },
  resize() {
    if (config.desktop) {
      calculate();
      floatTitle($floatingPoint);
      this.scroll();
    }
  },
  scroll() {
    floatTitle(needsFloating());
  },
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/floatingTitle.js